import React from 'react'
import { checkTextTranslation, checkTranslation, translate } from '../../utils/useful'
import SelectInput from './SelectInput'

class ColumnsCountInput extends React.Component {
    state = {
    }


    changeInputValue = (key, value) => {
        let data = this.props.data
        if (!data || typeof data != 'object') {
            data = {}
        }
        data[key] = value
        // console.log(data)
        this.props.changeValue(this.props.header.key, data, this.props.extra)

    }

    componentDidMount() {
        // console.log('this.props.data', this.props?.data)
    }
    focus = () => {
        this.input.focus()
    }
    selectHandler = () => {

    }



    render() {
        let styleInfo = this.props.styleInfo
        // console.log(this.props.data)

        return (
            <div className="w-100 h-100 flexc text-start"  >

                <div className='flexcb font-size-12 '>

                    <div className='text-center'>
                        <div className=" p-0 text-start flexc   br-4  " >
                            <img src='/assets/icons/useful/computer.png' height={18} alt='' />
                            <SelectInput data={this.props.data?.md} changeValue={this.changeInputValue} header={{ key: 'md', information: { placeholder: '{{lang}}Desktop', type: 'local', items: [{ value: '100%', title: '{{lang}}1 Card' }, { value: '50%', title: '{{lang}}2 Cards' }, { value: '33.33%', title: '{{lang}}3 Cards' }, { value: '25%', title: '{{lang}}4 Cards' }, { value: '20%', title: '{{lang}}5 Cards' }, { value: '16.66%', title: '{{lang}}6 Cards' }, { value: '14.28%', title: '{{lang}}7 Cards' }, { value: '12.5%', title: '{{lang}}8 Cards' }, { value: '11.11%', title: '{{lang}}9 Cards' }, { value: '10%', title: '{{lang}}10 Cards' }, { value: '9.09%', title: '{{lang}}11 Cards' }, { value: '8.33%', title: '{{lang}}12 Cards' }], required: true } }} />
                        </div>
                        {/* <p className="font-size-10 color-gray-1  mt-1 ">{translate('≥992px')}</p> */}
                    </div>
                    <div className='text-center'>
                        <div className=" p-0 text-start flexc  mx-1 br-4  " >
                            <img src='/assets/icons/useful/tablet.png' height={18} alt='' />
                            <SelectInput data={this.props.data?.sm} changeValue={this.changeInputValue} header={{ key: 'sm', information: { placeholder: '{{lang}}Tablet', type: 'local', items: [{ value: '100%', title: '{{lang}}1 Card' }, { value: '50%', title: '{{lang}}2 Cards' }, { value: '33.33%', title: '{{lang}}3 Cards' }, { value: '25%', title: '{{lang}}4 Cards' }, { value: '20%', title: '{{lang}}5 Cards' }, { value: '16.66%', title: '{{lang}}6 Cards' }, { value: '14.28%', title: '{{lang}}7 Cards' }, { value: '12.5%', title: '{{lang}}8 Cards' }, { value: '11.11%', title: '{{lang}}9 Cards' }, { value: '10%', title: '{{lang}}10 Cards' }, { value: '9.09%', title: '{{lang}}11 Cards' }, { value: '8.33%', title: '{{lang}}12 Cards' }], required: true } }} />
                        </div>
                        {/* <p className="font-size-10 color-gray-1  mt-1 ">{translate('576px≥x<576px')}</p> */}

                    </div>

                    <div className='text-center'>
                        <div className=" p-0 text-start flexc   br-4  " >
                            <img src='/assets/icons/useful/phone.png' height={18} alt='' />
                            {/* <input style={{ color: styleInfo?.textColor, fontWeight: styleInfo?.fontWeight, fontSize: styleInfo?.fontSize }} ref={el => this.input = el} autoFocus={this.props.header.information?.autoFocus} spellCheck={this.props.header.information?.spellCheck} data={this.props.data ? checkTranslation(this.props.data) : ''} changeValue={(e) => this.changeInputValueValue(e.target)} onClick={ this.selectHandler()} placeholder={checkTranslation(this.props.header.information?.placeholder)} disabled={this.props.header.information?.disabled} className="transpanet-input" /> */}
                            <SelectInput data={this.props.data?.xs} changeValue={this.changeInputValue} header={{ key: 'xs', information: { placeholder: '{{lang}}Mobile', type: 'local', items: [{ value: '100%', title: '{{lang}}1 Card' }, { value: '50%', title: '{{lang}}2 Cards' }, { value: '33.33%', title: '{{lang}}3 Cards' }, { value: '25%', title: '{{lang}}4 Cards' }, { value: '20%', title: '{{lang}}5 Cards' }, { value: '16.66%', title: '{{lang}}6 Cards' }, { value: '14.28%', title: '{{lang}}7 Cards' }, { value: '12.5%', title: '{{lang}}8 Cards' }, { value: '11.11%', title: '{{lang}}9 Cards' }, { value: '10%', title: '{{lang}}10 Cards' }, { value: '9.09%', title: '{{lang}}11 Cards' }, { value: '8.33%', title: '{{lang}}12 Cards' }], required: true } }} />
                            {/* <p className="font-size-11 text-semibold  mt-1 ">{translate('Mobile')}</p> */}
                        </div>
                        {/* <p className="font-size-10 color-gray-1  mt-1 ">{translate('<576px')}</p> */}
                    </div>


                </div>

                {/* <input ref={el => this.input = el} autoFocus={this.props.header.information?.autoFocus} spellCheck={this.props.header.information?.spellCheck} value={this.props.data ? checkTranslation(this.props.data) : ''} onChange={(e) => this.changeInputValue(e.target)} placeholder={checkTranslation(this.props.header.information?.placeholder)} disabled={this.props.header.information?.disabled} className="transpanet-input" /> */}

            </div>
        )
    }
}

export default ColumnsCountInput;